import { useState } from 'react';
import { ModulePermission } from 'src/components/ContactForm/types';
import { requestModulePermissions } from './helpers';

interface UseModulePermissionsAPIState {
  modulePermissions: ModulePermission[];
  isLoadingModulePermissions: boolean;
  modulePermissionsError: string | null;
}

export interface FetchModulePermissionsResult {
  ok: boolean;
  modulePermissions: ModulePermission[];
}

export interface UseModulePermissionsAPIReturn {
  modulePermissions: ModulePermission[];
  isLoadingModulePermissions: boolean;
  modulePermissionsError: string | null;
  onFetchModulePermissions: (
    propertyId: string
  ) => Promise<FetchModulePermissionsResult>;
}

export const useModulePermissionsAPI = (): UseModulePermissionsAPIReturn => {
  const [state, setState] = useState<UseModulePermissionsAPIState>({
    modulePermissions: [],
    isLoadingModulePermissions: false,
    modulePermissionsError: null,
  });

  const onFetchModulePermissions = async (
    propertyId: string
  ): Promise<FetchModulePermissionsResult> => {
    setState((prev: UseModulePermissionsAPIState) => ({
      ...prev,
      isLoadingModulePermissions: true,
      modulePermissionsError: null,
    }));

    try {
      const modulePermissions: ModulePermission[] =
        await requestModulePermissions(propertyId);

      setState({
        modulePermissions,
        isLoadingModulePermissions: false,
        modulePermissionsError: null,
      });

      return { ok: true, modulePermissions };
    } catch (err: any) {
      console.error('useModulePermissionsAPI fetch failed:', err);

      setState((prev: UseModulePermissionsAPIState) => ({
        ...prev,
        isLoadingModulePermissions: false,
        modulePermissionsError:
          err?.message || 'Failed to fetch module permissions',
      }));

      return { ok: false, modulePermissions: [] };
    }
  };

  return {
    modulePermissions: state.modulePermissions,
    isLoadingModulePermissions: state.isLoadingModulePermissions,
    modulePermissionsError: state.modulePermissionsError,
    onFetchModulePermissions,
  };
};